import { createClient, SupabaseClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL!;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY!;

// Base client (unauthenticated — only used before login)
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Cache the last authenticated client so we don't create a new one on every render
let cachedToken: string | null = null;
let cachedClient: SupabaseClient | null = null;

export function makeSupabaseClient(token: string | null): SupabaseClient {
  if (token && token === cachedToken && cachedClient) {
    return cachedClient;
  }

  const client = createClient(supabaseUrl, supabaseAnonKey, {
    global: {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    },
    auth: {
      persistSession: false,  // prevents GoTrueClient storage conflicts
      autoRefreshToken: false,
    },
  });

  cachedToken = token;
  cachedClient = client;
  return client;
}